import { ReactNode } from 'react';
import styled from 'styled-components';

import { NoAmp } from 'containers/NoAmp';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { namedBreakpoints } from 'theme';

import { FixedLayoutStaffTools } from './FixedLayoutStaffTools';

const StyledStickyBox = styled.div`
  transform: translateZ(0);
  position: sticky;
  top: 60px;
  z-index: 100;
  width: 100%;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    top: 0;
  }
`;

type Props = {
  content: CmsApiPage | undefined;
  postSearchToolbar: ReactNode | undefined;
};

export function LayoutContentToolbar({ content, postSearchToolbar }: Props) {
  return (
    <NoAmp>
      <StyledStickyBox>
        {postSearchToolbar}
        {content && <FixedLayoutStaffTools content={content} />}
      </StyledStickyBox>
    </NoAmp>
  );
}
